export default {
  lscsPath: 'https://api-cms.hktdc.com/ls/v2',
  projectNamePath: '%2F%2Fcmsapp%2F',
  apiContext: '',
  subDirectoryPath: '',
  routePathTo: ``,
  locationServiceEndPoint: 'https://api-general.hktdc.com/location/v1/location-service',
  footer_js_env: '',
  autoCompletePath: 'https://api-fair.hktdc.com/fair-core/v1/auto-complete',
  eventPath: 'https://event.hktdc.com',
  researchDomain: 'https://research.hktdc.com',
  sbeProgramePath: 'https://api-cms.hktdc.com/sbe/v1/seminar/programme',
  sbeSpeakerPath: 'https://api-cms.hktdc.com/sbe/v1/seminar/speakers',
  epcPath: 'https://www.hktdc.com/epc/webservice/subscription',
  epcAppId: 18,
  googleCaptchaAction: 'subscription',
  googleCaptchaPath: 'https://api-general.hktdc.com/captcha/v1/recaptcha/verify',
  googleSitekey: `${process.env.REACT_APP_CAPTURA_GOOGLE_SITEKEY1}${process.env.REACT_APP_CAPTURA_GOOGLE_SITEKEY2}${process.env.REACT_APP_CAPTURA_GOOGLE_SITEKEY3}`,
  tencentCaptchaPath: 'https://api-general.hktdc.com/captcha/v1/tencent/verify',
  tencentCaptchaAppId: `${process.env.REACT_APP_CAPTURA_TENCENT_CAPTCHA_APP_ID1}${process.env.REACT_APP_CAPTURA_TENCENT_CAPTCHA_APP_ID2}${process.env.REACT_APP_CAPTURA_TENCENT_CAPTCHA_APP_ID3}`,
  captchaLocationPath: 'https://api-cms.hktdc.com/captcha/location',
  xApiKey: `${process.env.REACT_APP_CAPTURA_API_KEY1}${process.env.REACT_APP_CAPTURA_API_KEY2}${process.env.REACT_APP_CAPTURA_API_KEY3}`,
};
